<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="mb10">活动名称</p>
    <el-input v-model.trim="form.name" style="width: 220px"></el-input>

    <p class="mb10 mt20">活动优先级（数字越大排序越靠前）</p>
    <el-input v-model.trim="form.campaignScore" type="number" style="width: 220px" placeholder="输入1～1000内的数字"></el-input>
    <table class="table mt20">
      <tr>
        <td class="w300">角标</td>
        <td class="w230">手续费比例</td>
      </tr>
      <tr>
        <td>
          <div class="upload-btn">
            <img v-if="form.techServiceFeeTagUrl" class="tag-img" :src="form.techServiceFeeTagUrl" alt="">
            <el-button v-else type="primary" icon="el-icon-upload" size="mini" plain>上传角标</el-button>
            <input @change="(e) => changeFile(e, 1)" accept=".jpg,.jpeg,.png" type="file" />
          </div>
        </td>
        <td>
          <el-input placeholder="0~10" v-model="form.techServiceFeePercent" @input="inputNumber" size="small" style="width: 200px">
            <i slot="suffix" class="el-input__icon">%</i>
          </el-input>
        </td>
      </tr>
    </table>

    <p class="mb10 mt20">选择生效时间</p>
    <el-date-picker
      v-model="daterange"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :default-time="['00:00:00', '23:59:59']"
      value-format="timestamp"
      style="width: 500px">
    </el-date-picker>
    <table class="table mt20">
      <tr>
        <td class="w300">缺货是否生效</td>
      </tr>
      <tr>
        <td>
          <el-switch v-model="form.isForOutOfStock"></el-switch>
        </td>
      </tr>
    </table>
    <table class="table mt20">
      <tr>
        <td class="w300">出售是否生效</td>
        <td class="w230">求购是否生效</td>
      </tr>
      <tr>
        <td>
          <el-switch v-model="form.isForSale"></el-switch>
        </td>
        <td>
          <el-switch v-model="form.isForBuyOffer"></el-switch>
        </td>
      </tr>
    </table>

    <el-tabs class="mt20" v-model="form.scopeType" type="card" @tab-click="handleClick">
      <el-tab-pane label="指定品牌品类" name="brand_category" :disabled="isEdit"></el-tab-pane>
      <el-tab-pane label="SPU导入" name="spu" :disabled="isEdit"></el-tab-pane>
    </el-tabs>

    <template v-if="form.scopeType === 'brand_category'">
      <span>选择品牌</span>
      <BrandSelect :data="brandList" v-model="brandIds" multiple clearable style="width: 220px"></BrandSelect>
      <span class="ml20">选择品类</span>
      <el-cascader ref="Cascader" v-model="categoryIds" :options="categoryList" :props="optionProps" clearable style="width: 220px"></el-cascader>
      <el-button class="ml20" type="primary" icon="el-icon-upload" plain :disabled="brandIds.length === 0 || categoryIds.length === 0" @click="onClickAdd">添加</el-button>

      <el-table class="mt20" :data="brandCategoryScopes" style="width: 100%">
        <el-table-column prop="createdAt" label="添加日期">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="brandNamesStr" label="品牌"></el-table-column>
        <el-table-column prop="categoryNamesStr" label="品类"></el-table-column>
        <el-table-column prop="updatedBy" label="操作人"></el-table-column>
        <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" @click="removeItem(scope)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-if="form.scopeType === 'spu'">
      <p class="mb10">SPU导入</p>
      <div class="upload-container">
        <div class="upload-btn">
          <el-button type="primary" icon="el-icon-upload" plain>点击上传</el-button>
          <input @change="(e) => changeFile(e, 2)" accept=".xls,.xlsx" type="file" />
        </div>
        <!-- <el-button type="text" @click="downloadTemplate">下载文件模板</el-button> -->
      </div>
      <p class="mt10 gray">只能上传.xls .xlsx</p>
      <el-button type="text" @click="downloadTemplate" icon="el-icon-download">下载文件模板</el-button>
      <template v-if="form.spuScope.fileName">
        <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ form.spuScope.fileName }}</div>
        <el-button class="ml20" type="text" size="mini" @click="downloadFile(form.spuScope.fileUrl)">下载</el-button>
      </template>
    </template>

    <div class="mt20">
      <el-button type="primary" @click="submitUpload">保存生效</el-button>
      <el-button @click="$router.back()">返回</el-button>
    </div>

    <el-dialog title="保存失败" :visible.sync="dialogVisible" width="400px">
      <p v-if="uploadResultFileUrl"><el-link type="primary" @click="downloadResultFile">下载文件解析结果</el-link>（请根据错误原因更新文件后重新提交）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Client from "@/utils/client.js";
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import { fileUpload } from '../../../api/merchants';
import {
  getBrandList,
  getCategory,
  getSellerServiceFeePromotion,
  saveSellerServiceFeePromotion,
  queryImageInfo,
} from '../api';
import BrandSelect from '../../shared/brandSelect.vue';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      fullscreenLoading: false,
      isEdit: this.$route.params.id,
      activeName: 'first',
      daterange: [],
      brandList: [],
      categoryList: [],
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'chineseName',
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: true,
        multiple: true
      },
      form: {
        name: null,
        campaignScore: null,
        techServiceFeeTagUrl: null,
        techServiceFeePercent: null,
        tagWidth: null,
        tagHeight: null,
        scopeType: 'brand_category',
        isForSale: true,
        isForOutOfStock: false,
        isForBuyOffer: false,
        spuScope: {
          fileUrl: null,
          fileName: null,
        },
        brandCategoryScopes: [],
      },
      brandIds: [],
      categoryIds: [],
      brandCategoryScopes: [],
      dialogVisible: false,
      uploadResultFileUrl: null,
    };
  },
  computed: {
    ...mapState({
      userName: state => state.user.userDetail.name,
    }),
  },
  created() {
    getBrandList().then(res => {//获取品牌列表
      this.brandList = (res.data || []).map(item => {
        return {
          label: item.englishName,
          value: item.brandId
        };
      });
    });
    getCategory().then(res => {
      this.categoryList = res.data || [];
    });
    if (this.$route.params.id) {
      this.getSellerServiceFeePromotion();
    }
  },
  methods: {
    getSellerServiceFeePromotion() {
      getSellerServiceFeePromotion(this.$route.params.id).then(res => {
        if (res.data && res.data.success) {
          res.data.data.spuScope = res.data.data.spuScope || {};
          this.form = res.data.data;
          this.daterange = [this.form.startTime, this.form.endTime];
          this.brandCategoryScopes = res.data.data.brandCategoryScopes || [];
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      })
    },
    handleClick() {

    },
    inputNumber(val) {
      // 替换掉数字和小数点 . 之外的字符
      val = val.replace(/[^\d.]/g, '');
      // 把2个以上的小数点 . 替换成一个小数点 .
      val = val.replace(/\.{2,}/g, '.');
      // 保证第一个字符为数字而不是小数点 .
      val = val.replace(/^\./g, '');
      // 保证小数点 . 只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      // 只能输入两个小数
      // val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (val > 10) {
        val = 10;
      }
      this.form.techServiceFeePercent = val;
    },
    async changeFile(e, type) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (type === 1 && !/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (type === 2 && !/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        if (type === 1) {
          const resInfo = await queryImageInfo(res.url);
          if (resInfo.data && resInfo.data.ImageWidth) {
            this.form.techServiceFeeTagUrl = res.url;
            this.form.tagWidth = resInfo.data.ImageWidth.value;
            this.form.tagHeight = resInfo.data.ImageHeight.value;
          }
        } else {
          this.form.spuScope.fileUrl = res.url;
          this.form.spuScope.fileName = file.name.substring(file.name.lastIndexOf('/'));
        }
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    submitUpload() {
      if (!this.form.name) {
        this.$message('请输入活动名称');
        return;
      }
      if (this.form.campaignScore && (this.form.campaignScore< 1 || this.form.campaignScore > 1000)) {
        this.$message('活动优先级：输入1～1000内的数字');
        return;
      }
      if (!this.form.techServiceFeeTagUrl) {
        this.$message('请上传角标图片');
        return;
      }
      if (!this.form.techServiceFeePercent) {
        this.$message('请输入手续费比例');
        return;
      }
      if (!this.daterange || this.daterange.length === 0) {
        this.$message('请选择生效时间');
        return;
      }
      if (this.form.scopeType === 'spu' && !this.form.spuScope.fileUrl) {
        this.$message('请上传SPU导入文件');
        return;
      }
      this.uploadResultFileUrl = null;
      this.$confirm(`确认信息无误？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.repeatSubmit) {
          return;
        }
        this.repeatSubmit = true;
        this.fullscreenLoading = true;
        saveSellerServiceFeePromotion({
          ...this.form,
          startTime: this.daterange[0] || null,
          endTime: this.daterange[1] || null,
          brandCategoryScopes: this.brandCategoryScopes,
        }).then((res) => {
          if (res.data && res.data.success) {
            if (res.data.code === '1001') {
              this.uploadResultFileUrl = res.data.data;
              this.dialogVisible = true;
            } else {
              this.$message.success('保存成功');
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            }
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000)
        }).catch(() => {
          this.fullscreenLoading = false;
          setTimeout(() => {
            this.repeatSubmit = false;
          }, 2000)
        });
      }).catch(() => {});
    },
    downloadResultFile() {
      downloadUrlFile(this.uploadResultFileUrl);
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onClickAdd() {
      if (this.brandIds.length === 0) {
        this.$message('请选择品牌');
        return;
      }
      if (this.categoryIds.length === 0) {
        this.$message('请选择品类');
        return;
      }
      const nodes = this.$refs.Cascader.getCheckedNodes();
      console.log(nodes);
      const categoryIds = [];
      const categoryNames = [];
      nodes.forEach(node => {
        if (node.hasChildren) {
          node.children.forEach(item => {
            if (item.hasChildren) {
              item.children.forEach(item2 => {
                categoryIds.push(item2.data.categoryId);
              });
            } else {
              categoryIds.push(item.data.categoryId);
            }
          });
        } else {
          categoryIds.push(node.data.categoryId);
        }
        categoryNames.push(node.pathNodes.map(n => n.label).join('>'));
      });
      this.brandCategoryScopes.push({
        id: null,
        createdAt: Date.now(),
        updatedBy: this.userName,
        brandIds: this.brandIds,
        brandNamesStr: this.brandIds.map(item => {
          const brand = this.brandList.find(item2 => item2.value === item);
          return brand.label;
        }).join(','),
        categoryIds: categoryIds,
        categoryNamesStr: categoryNames.join(','),
      });
    },
    removeItem(scope) {
      this.brandCategoryScopes.splice(scope.$index, 1);
    },
    downloadFile(url) {
      downloadUrlFile(url);
    },
    downloadTemplate() {
      downloadUrlFile("https://product-sts.oss-cn-shanghai.aliyuncs.com/upload/费率活动spu导入模版.xlsx");
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mt30 {
  margin-top: 30px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.gray {
  color: #939da9;
}
.bg-gray {
  background-color: #f2f2f2;
}
.f16 {
  font-size: 16px;
}
.upload-btn {
  display: inline-block;
  position: relative;
  margin-right: 50px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
.table {
  border-spacing: 0;
  border-collapse: collapse;
  text-align: left;
  td,th {
    padding: 5px 0;
  }
  .w300 {
    width: 300px;
  }
  .w230 {
    width: 230px;
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
.tag-img {
  display: block;
  max-width: 200px;
}
</style>
